module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-container', {
    staticClass: "step-container"
  }, [_c('el-aside', {
    attrs: {
      "width": "200px"
    }
  }, [_c('el-page-header', {
    staticClass: "page-header",
    attrs: {
      "content": _vm.title
    },
    on: {
      "back": _vm.back
    }
  })], 1), _vm._v(" "), _c('el-main', {
    staticClass: "step-main"
  }, [_c('el-steps', {
    staticClass: "steps",
    attrs: {
      "active": _vm.active,
      "align-center": ""
    }
  }, _vm._l((_vm.steps), function(item, index) {
    return _c('el-step', {
      key: index,
      attrs: {
        "title": item
      }
    })
  }), 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b0ab16a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reserve/steps/index.vue
// module id = gdHi
// module chunks = 0